/**
 * Picks v2 or v1 of the API Key form based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import ApiKeyFormPage   from './ApiKeyFormPage';
import ApiKeyFormPageV2 from './v2/ApiKeyFormPageV2';

export default function ApiKeyFormPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? ApiKeyFormPageV2 : ApiKeyFormPage;
  return <Component {...props} />;
}
